module.exports = __webpack_public_path__ + "static/media/anc13ru.0f502538.pdf";